import PropTypes from 'prop-types'
import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  ButtonGroup
} from 'react-bootstrap'
import Button from 'components/Button'
import ColorPicker from 'components/ColorPicker'

export class CreateLabelForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired,
  }

  renderNameField = (field) => {
    const onInputFocus = (event) => {
      const tempValue = event.target.value
      event.target.value = ''
      event.target.value = tempValue
    }

    return (
      <FormGroup
        validationState={field.meta.touched && field.meta.error ? 'error' : null}>
        <ControlLabel><FormattedMessage id='NAME' /></ControlLabel>
        <FormControl
          {...field.input}
          name={null}
          autoFocus
          type='text'
          onFocus={onInputFocus}
        />
        {field.meta.touched && field.meta.error && <HelpBlock>{field.meta.error}</HelpBlock>}
      </FormGroup>
    )
  }

  renderColorField = (field) => {
    return (
      <FormGroup>
        <ControlLabel><FormattedMessage id='LABEL_COLOR' /></ControlLabel>
        <div>
          <ColorPicker
            value={field.input.value}
            onChange={field.input.onChange}
          />
        </div>
      </FormGroup>
    )
  }

  render () {
    const {
      handleSubmit,
      onCancelClick
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name='name'
          component={this.renderNameField}
        />
        <Field
          name='color'
          component={this.renderColorField}
        />
        <ButtonGroup>
          <Button
            type='submit'
            bsStyle='primary'
          >
            <FormattedMessage id='LABEL_CREATE' />
          </Button>
          <Button
            onClick={onCancelClick}
          >
            <FormattedMessage id='CANCEL' />
          </Button>
        </ButtonGroup>
      </form>
    )
  }
}

export default reduxForm()(CreateLabelForm)
